import { Star, ArrowUpRight } from "lucide-react";
import { FadeIn, MaskedLineScroll, Overline } from "@/components/Reveal";

const GOOGLE_URL = "https://share.google/h345kVjFkdJgwaBrQ";

export default function Avis() {
  return (
    <section className="bg-white py-20 md:py-28 border-b border-midnight/10" data-testid="avis-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <Overline>Avis clients</Overline>
          <h2 className="mt-4 font-display font-black uppercase tracking-tighter leading-[0.95] text-3xl sm:text-4xl lg:text-5xl">
            <MaskedLineScroll>La confiance de nos</MaskedLineScroll>
            <MaskedLineScroll delay={0.12}>clients du <span className="text-signal">Val-de-Marne</span></MaskedLineScroll>
          </h2>
          <FadeIn delay={0.2}>
            <p className="mt-6 text-base md:text-lg text-midnight/70 leading-relaxed max-w-2xl">
              Notre réputation se construit chantier après chantier, à Champigny-sur-Marne et dans tout le 94.
              Retrouvez les avis de nos clients sur notre fiche Google — de vrais avis, de vrais chantiers.
              Et si nous avons travaillé chez vous, votre avis nous aide à faire connaître notre savoir-faire.
            </p>
          </FadeIn>
        </div>
        <div className="lg:col-span-4 lg:col-start-9">
          <FadeIn delay={0.25}>
            <a
              href={GOOGLE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="avis-google-button"
              className="group block border border-midnight/10 bg-bone p-8 hover:border-signal transition-colors duration-300"
            >
              <div className="flex items-center gap-1 text-signal">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={20} strokeWidth={1.5} />
                ))}
              </div>
              <p className="mt-4 font-display font-extrabold uppercase tracking-tight text-lg flex items-center gap-2">
                Voir nos avis Google
                <ArrowUpRight size={18} strokeWidth={1.5} className="text-signal group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
              </p>
              <p className="mt-2 text-sm text-midnight/60">
                Fiche Google Business Profile — MSC Toitures, Champigny-sur-Marne
              </p>
            </a>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}
